<p>
  coa-logout works!
</p>
